import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, startLoading, setEnrollmentUsers, setEnrollmentUsersSearch, setSingleEnrollmentUser, setUpdateEnrollmentUser, setDeleteEnrollmentUser } from '../reducers/enrollmentSlice';

export const actionCreateEnrollment = ({postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.createEnrollment({postData})
        dispatch({
            type: setEnrollmentUsers.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchEnrollmentUsers = ({page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchEnrollmentUsers({page})
        dispatch({
            type: setEnrollmentUsers.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchEnrollmentsBySearch = ({searchQuery, page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchEnrollmentsBySearch({searchQuery, page})
        dispatch({
            type: setEnrollmentUsersSearch.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchEnrollmentUser = ({id}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchEnrollmentUser({id});
        dispatch({
            type: setSingleEnrollmentUser.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionUpdateEnrollment = ({id, postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.updateEnrollment({id, postData})
        dispatch({
            type: setUpdateEnrollmentUser.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionDeleteEnrollment = ({id}: api.ApiParams) => async (dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const data = await api.deleteEnrollment({id})
        dispatch({
            type: setDeleteEnrollmentUser.type,
            payload: id
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}